export function minMaxDate(date: Date, minDate: Date | undefined, maxDate: Date | undefined): Date {
  let result = date
  if (minDate && date < minDate) {
    result = minDate
  }
  if (maxDate && date > maxDate) {
    result = maxDate
  }
  return result
}
